"use client";

interface KeywordLabelProps { text: string; }

export function KeywordLabel({ text }: KeywordLabelProps) {
  return (
    <div className="inline-flex items-center justify-center shrink-0 rounded-[4px] bg-[#e4e5e9] px-2 lg:px-2.5 py-1 lg:py-[5px] leading-none">
      <span className="font-['Pretendard:Medium',_sans-serif] text-[#010103] text-sm lg:text-[14px] tracking-[-0.2px] whitespace-nowrap">
        {text}
      </span>
    </div>
  );
}

